export const parseFlexibleNumber = (rawValue?: string | number | null): number => {
  if (typeof rawValue === 'number') return Number.isFinite(rawValue) ? rawValue : 0;

  const text = String(rawValue || '').trim().replace(/\s+/g, '');
  if (!text) return 0;

  const hasDot = text.includes('.');
  const hasComma = text.includes(',');

  if (hasDot && hasComma) {
    const lastDot = text.lastIndexOf('.');
    const lastComma = text.lastIndexOf(',');
    const decimalSeparator = lastDot > lastComma ? '.' : ',';
    const thousandSeparator = decimalSeparator === '.' ? ',' : '.';

    const normalized = text
      .split(thousandSeparator)
      .join('')
      .replace(decimalSeparator, '.');

    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  if (hasDot || hasComma) {
    const separator = hasDot ? '.' : ',';
    const parts = text.split(separator);

    if (parts.length > 2) {
      const parsed = Number(parts.join(''));
      return Number.isFinite(parsed) ? parsed : 0;
    }

    const [leftPart = '', rightPart = ''] = parts;
    if (!rightPart) {
      const parsed = Number(leftPart);
      return Number.isFinite(parsed) ? parsed : 0;
    }

    if (!leftPart) {
      const parsed = Number(`0.${rightPart}`);
      return Number.isFinite(parsed) ? parsed : 0;
    }

    const isDecimalStyle = rightPart.length <= 2;
    if (!isDecimalStyle) {
      const parsed = Number(`${leftPart}${rightPart}`);
      return Number.isFinite(parsed) ? parsed : 0;
    }

    const parsed = Number(`${leftPart}.${rightPart}`);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  const parsed = Number(text);
  return Number.isFinite(parsed) ? parsed : 0;
};

/**
 * Hiển thị số kiểu vi-VN cho InputNumber.
 * useGrouping: false — tránh "1000" → "1.000"; khi sửa/xóa ký tự parser không còn nhầm "1.00" thành 1.
 */
export const formatFlexibleNumber = (
  value?: string | number | null,
  maxFractionDigits: number = 2
): string => {
  if (value === undefined || value === null || value === '') return '';
  const parsed = parseFlexibleNumber(value);
  return parsed.toLocaleString('vi-VN', {
    maximumFractionDigits: maxFractionDigits,
    useGrouping: false,
  });
};

/** Tham số thứ 2 do rc-input-number / Ant Design 5 truyền vào formatter. */
export type InputNumberFormatInfo = {
  userTyping?: boolean;
  input?: string;
};

/**
 * Formatter an toàn cho InputNumber: khi user đang gõ, giữ nguyên chuỗi trong ô (không ép qua locale),
 * tránh lỗi xóa từng chữ số sau khi hiển thị dạng có dấu phân tách nghìn.
 */
export function formatInputNumberFormatter(maxFractionDigits = 6) {
  return (value: string | number | undefined, info?: InputNumberFormatInfo): string => {
    if (info?.userTyping) return String(info.input ?? '');
    return formatFlexibleNumber(value, maxFractionDigits);
  };
}
